// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__HIe4G","txt":"style_txt__faLtH","outerdiv":"style_outerdiv__88ZLH"};